import { render, staticRenderFns } from "./Approvers.vue?vue&type=template&id=a10826d4&"
import script from "./Approvers.vue?vue&type=script&lang=ts&"
export * from "./Approvers.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports